export default __webpack_public_path__ + "static/media/breakfast.e60b0654.svg";